@import '../../../globals/main.scss';

:host {
  display: block;
}

.pn-marketweb-table {
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem;
  }

  .heading-section {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    margin-bottom: 2rem;

    @media (max-width: $min-width-md) {
      flex-direction: column;
    }

    .heading-wrapper {
      display: flex;
      flex-direction: column;
    }

    .preamble-section {
      width: 80%;
    }

    .main-heading {
      margin-bottom: 1rem;
    }

    .summary {
      display: flex;
      height: 7rem;
      justify-content: flex-end;
      gap: clamp(1rem, 4vw, 2rem);

      @media (max-width: $min-width-md) {
        justify-content: center;
      }
    }

    .sub-heading-section {
      background-color: $blue25;
      border-radius: 1.6rem;
      display: flex;
      align-items: center;
      gap: clamp(0.6rem, 4vw, 1rem);
      padding: 0.6rem 1.2rem;
      width: 13.5rem;

      .icon-container {
        background-color: $blue50;
        border-radius: 50%;
        padding: 4px;
      }
    }

    .sub-heading {
      font-size: clamp(1rem, 3vw, 1.4rem);
      font-weight: 400;
      line-height: clamp(1.225rem, 4vw, 1.5rem);
      margin: 0;

      strong {
        color: $blue700;
        font-weight: 700;
      }
    }
  }

  .pn-marketweb-table__table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 3.2rem;
    border: none;
  }

  .pn-marketweb-table__table tr {
    border-bottom: 1px solid $gray100;
    position: relative;
    border-left: 4px solid $white;
    transition: all .7s ease;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      border-left: 4px solid $blue200;
      background: $blue25;
    }

    &.row-new-message,
    &.row-new-messag:hover {
      border-left: 4px solid $green500;
      background: linear-gradient(90deg, rgba(220, 246, 231, 1) 0%, rgba(237, 251, 243, 1) 30%, rgba(255, 255, 255, 1) 70%);
    }
  }

  .pn-marketweb-table__table {
    td {
      padding: 1.6rem 1rem;
    }
  }

  .image-container {
      min-height: 5.8rem;
  }

  .cell-heading {
    color: $gray700;
    font-size: clamp(0.875rem, 4vw, 1.2rem);
    font-weight: 400;
    line-height: clamp(1.225rem, 4vw, 1.5rem);
    margin: 0;
  }

  .cell-value {
    color: $gray900;
    display: inline-block;
    font-size: clamp(1rem, 4vw, 1.5rem);
    font-weight: 400;
    line-height: clamp(1.4rem, 4vw, 1.8rem);
    margin: 0;
    padding: 0.5rem 0;
  }

  .row-image {
    border-radius: 0.5rem;
  }

  .actions {
    align-content: center;
    width: 20%;

    .button-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      gap: 1.6rem;

      pn-button {
        min-width: 50%;
      }

      pn-button.toggle-widget {
        min-width: 30%;
      }

      .pn-button-text {
        white-space: nowrap;
      }

      @media screen and (max-width: $min-width-md) {
        justify-content: space-between;
        flex-direction: column;
      }
    }
  }

  @media screen and (max-width: $min-width-md) {
    tr {
      display: flex;
      flex-wrap: wrap;
    }

    td:not(.cell-content) {
      width: 100%;
    }

    td.cell-image {
      text-align: center;
    }

    td.cell-content {
      flex: 1 0 40%;

      &::before {
        content: attr(data-label);
        display: block;
        font-weight: bold;
        margin-bottom: 0.5em;
      }
    }

    td.actions .button-wrapper {
      gap: 2rem;
    }
  }

  @media (min-width: $min-width-md) {
    .row-image {
      max-width: 80px;
    }
  }

  .toggle-detail {
    display: none;
    color: $blue700;
    cursor: pointer;
    border: none;
    border-radius: 3em;
    outline: none;
    position: relative;
    font-size: 0.875em;
    min-width: 5.5em;
    font-weight: 500;
    background-color: transparent;
    justify-content: center;
    align-items: center;
    transition: color 0.3s;
    -webkit-tap-highlight-color: transparent;
    text-decoration: none;
    padding: 0.375em 1em;
    min-height: 2em;
    line-height: 1.65em;
    white-space: nowrap;

    &:hover {
      background-color: $blue50;
      opacity: 1;
    }
  }

  .shipment-id-active .button-wrapper {
    display: flex;
  }

  tr td.cell-content:first-child .cell-value {
    font-weight: 500;
  }

  .pn-widget-wrapper {
    display: flex;
    justify-content: center;
  }

  .shipment-id-active, .widget-row {
    background-color: $blue25;
  }

  .pn-market-table__show-more-wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}



.row-new-message .button-wrapper:after {
  content: attr(data-label);
  background: $green500;
  border-radius: 0 0.4rem .4rem 0;
  color: $white;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1.4rem;
  padding: 0 .4rem;
}

@media (min-width: $min-width-md) {
  .row-new-message .button-wrapper:after {
    background: $green700;
    border-radius: .4rem;
    left: auto;
    right: 1.6rem;

    font-size: 1.1rem;
    top: .3rem;

  }
}